import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12">
          <div>
            <span className="text-xs md:text-sm text-foreground-400 tracking-widest uppercase font-medium">
              Popularne kolekcje
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
              Przeglądaj
              <br />
              <span className="italic font-normal text-foreground-600">kategorie</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 mt-4 lg:mt-0 max-w-md">
            Odkryj nasze starannie wyselekcjonowane kategorie produktów. Każda kategoria zawiera sprawdzone produkty z najlepszych chińskich platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-2xl bg-background-50 overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.namePl}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="text-xs md:text-sm font-medium text-white leading-tight block">
                    {cat.namePl}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}